module.exports = __webpack_public_path__ + "img/mobile-product-card.77fdc002.svg";